/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { Popover } from "bootstrap"
import { CSSProperties, FC } from "react"

interface Props {
  content: string
  htmlContent?: boolean
  style?: CSSProperties
}

const setupPopover = (popoverElement: Element) => {
  new Popover(popoverElement, {
    trigger: "hover",
    delay: { show: 200, hide: 100 },
  })
}

export const setupPopovers = () => {
  const popoverTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'))
  popoverTriggerList.forEach(setupPopover)
}

export const InfoPopover: FC<Props> = ({ content, htmlContent, style }) => {
  return (
    <i
      className="fas fa-info-circle ps-2 fs-6"
      data-bs-toggle="popover"
      data-bs-trigger="hover"
      data-bs-html={htmlContent ? "true" : "false"}
      data-bs-content={content}
      style={style}
    ></i>
  )
}
